import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { categoriesData } from "../../helpers/Arrays";
import { Images } from "../../helpers/Images";
import { ArrowDownWideNarrow, ArrowDown } from "lucide-react";
import { Gallery } from "../../helpers/gallery";

const CategoriesTemplate = () => {
  const navigate = useNavigate();
  const [type, setType] = useState("Engineers");
  return (
    <>
      {/* <Box
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        }}
      >
        <Typography
          variant={"h1"}
          sx={{
            textAlign: "center",
            fontSize: { xs: "40px", sm: "55px" },
            fontWeight: "500",
            color: "primary.darker",
          }}
        >
          Robot Challenge Egypt 2023
        </Typography>
        <Box
          sx={{
            height: "3px",
            maxWidth: { xs: "100px", md: "350px" },
            width: "100%",
            backgroundColor: "primary.main",
            margin: "10px auto 0 auto",
          }}
        />
        <Typography
          sx={{
            textAlign: "center",
            color: "primary.darker",
            maxWidth: "750px",
            margin: "40px auto 10px auto",
            fontSize: "17px",
          }}
        >
          Each year RobotChallenge Egypt, one of the world’s largest artificial
          intelligent robotic championships, brings together people from all
          over Egypt who compete with self-made, autonomous robots in various
          competitions.
        </Typography>
      </Box> */}
      <Box
        id={"categories"}
        sx={{
          width: "100%",
          maxWidth: "1500px",
          margin: "auto",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        }}
      >
        <Typography
          variant={"h1"}
          sx={{
            textAlign: "center",
            fontSize: { xs: "40px", sm: "55px" },
            fontWeight: "500",
            color: "primary.darker",
          }}
        >
          Our Categories
        </Typography>
        <Box
          sx={{
            height: "3px",
            maxWidth: { xs: "100px", md: "200px" },
            width: "100%",
            backgroundColor: "primary.main",
            margin: "5px auto 0 auto",
          }}
        />

        {/* <Typography
          variant={"p"}
          sx={{
            textAlign: "start",
            fontSize: { xs: "25px", sm: "18px" },
            fontWeight: "400",
            color: "black",
            maxWidth: "83%",
            margin: "auto",
            display: "block",
            marginTop: "20px",
          }}
        >
          The We Do Challenge is a fun and educational robotics competition for
          young children, offering two categories: WeDo Researchers (ages 4–6),
          where kids explore STEAM concepts through playful model building and
          simple research, and WeDo Engineers (ages 6–10), where teams solve
          real-world problems using LEGO or similar kits while learning teamwork
          and critical thinking. Designed to be affordable and inclusive, the
          event inspires creativity and a love of learning at every level.
        </Typography> */}
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: "10px",
            justifyContent: "center",
            marginBottom: "20px",
            transition: "2s",
          }}
        >
          <Grid
            item
            xs={6}
            md={type == "Researchers" ? 7 : 5}
            sx={{
              transition: "0.7s",
            }}
          >
            <Box
              sx={{
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.8)), url(${Gallery.gallery19})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                minHeight: { xs: "150px", sm: "200px" },
                borderRadius: "10px",
                position: "relative",
              }}
            >
              <Typography
                variant={"h3"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "23px", md: "35px" },
                  fontWeight: "500",
                  color: "secondary.main",
                }}
              >
                We Do Researchers
              </Typography>
              <Typography
                variant={"h4"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "18px", md: "25px" },
                  fontWeight: "500",
                  color: "secondary.main",
                  margin: "5px 0",
                }}
              >
                4 - 6 years
              </Typography>
              {type != "Researchers" ? (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color={type == "Researchers" ? "primary" : "secondary"}
                    sx={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "primary.main",
                      width: "fit-content",
                      margin: { xs: "0px 0 0 0", sm: "10px 0 0 0" },
                      color: type == "Researchers" ? "white" : "primary.main",
                    }}
                    onClick={() => setType("Researchers")}
                  >
                    see all
                  </Button>
                </Box>
              ) : (
                <ArrowDown
                  style={{
                    color: "#fff",
                    width: "25px",
                    height: "25px",
                    margin: "5px auto 0",
                  }}
                />
              )}
              {/* {type == "Researchers" ? (
                <ArrowDownWideNarrow
                  style={{
                    position: "absolute",
                    color: "#c11a83",
                    width: "40px",
                    height: "40px",
                    bottom: "-50px",
                    left: "calc(50% - 20px)",
                  }}
                />
              ) : (
                ""
              )} */}
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            md={type == "Engineers" ? 7 : 5}
            sx={{
              transition: "0.7s",
            }}
          >
            <Box
              sx={{
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.8)), url(${Gallery.gallery6})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                minHeight: { xs: "150px", sm: "200px" },
                borderRadius: "10px",
                padding: "0 10px",
                position: "relative",
              }}
            >
              <Typography
                variant={"h3"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "25px", md: "35px" },
                  fontWeight: "500",
                  color: "secondary.main",
                }}
              >
                We Do Engineers
              </Typography>
              <Typography
                variant={"h4"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "18px", md: "25px" },
                  fontWeight: "500",
                  color: "secondary.main",
                  margin: "5px 0",
                }}
              >
                6 - 12 years
              </Typography>

              {type != "Engineers" ? (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color={type == "Engineers" ? "primary" : "secondary"}
                    sx={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: type == "Engineers" ? "white" : "primary.main",
                      width: "fit-content",
                      margin: { xs: "0px 0 0 0", sm: "10px 0 0 0" },
                    }}
                    onClick={() => setType("Engineers")}
                  >
                    see all
                  </Button>
                </Box>
              ) : (
                <ArrowDown
                  style={{
                    color: "#fff",
                    width: "25px",
                    height: "25px",
                    margin: "5px auto 0",
                  }}
                />
              )}
              {/* {type == "Engineers" ? (
                <ArrowDownWideNarrow
                  style={{
                    position: "absolute",
                    color: "#c11a83",
                    width: "40px",
                    height: "40px",
                    bottom: "-50px",
                    left: "calc(50% - 20px)",
                    transform: "rotateY(180deg)",
                  }}
                />
              ) : (
                ""
              )} */}
            </Box>
          </Grid>
        </Grid>
        {type ? (
          <Box
            sx={{
              maxWidth: "95%",
              margin: "auto",
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              {categoriesData
                ?.filter((ty) => ty.type.includes(type))
                ?.map((item) => (
                  <Grid item xs={12} md={6} xl={4}>
                    <Box
                      sx={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${item.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        width: "100%",
                        minHeight: { xs: "180px", sm: "250px" },
                        borderRadius: "10px",
                      }}
                    >
                      <Typography
                        variant={"h3"}
                        sx={{
                          textAlign: "center",
                          fontSize: "35px",
                          fontWeight: "500",
                          color: "secondary.main",
                        }}
                      >
                        {item.title}
                      </Typography>

                      <Typography
                        variant={"h4"}
                        sx={{
                          textAlign: "center",
                          fontSize: { xs: "18px", md: "25px" },
                          fontWeight: "500",
                          color: "secondary.main",
                          margin: "0px 0",
                        }}
                      >
                        {item?.age}
                      </Typography>
                      <Box
                        sx={{
                          height: "3px",
                          maxWidth: "90px",
                          width: "100%",
                          backgroundColor: "secondary.main",
                          margin: "5px auto 5px auto",
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "primary.main",
                            width: "fit-content",
                            margin: { xs: "5px 0 20px 0", sm: "5px 0 20px 0" },
                          }}
                          onClick={() => navigate(item.link)}
                        >
                          more details
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Box>
        ) : (
          ""
        )}
      </Box>
    </>
  );
};

export default CategoriesTemplate;
